import { render } from "./OfficeMemorandum.vue?vue&type=template&id=21ce55ea"
import script from "./OfficeMemorandum.vue?vue&type=script&lang=js"
export * from "./OfficeMemorandum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__